import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {EntidadeConfig, EntidadeEnum} from 'src/app/api/module/erp/shared/enumerable/entidade.enum';
import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-formulario-dados-bancarios-proposta',
  templateUrl: './formulario-dados-bancarios-proposta.component.html',
  styleUrls: ['./formulario-dados-bancarios-proposta.component.scss'],
})
export class FormularioDadosBancariosPropostaComponent implements OnInit, AfterViewInit {
  readonly TipoPropostaEnum = TipoPropostaEnum;
  formularioDadosBancarios!: FormGroup;
  @Input() entidadeProposta: string = '';
  @Input() razaoSocialEntidade: string = '';
  @Input() codigoProposta: string = '';
  @Input() vigenciaProposta: string = '';
  @Input() nomeTitular: string = '';
  @Input() tipoPlano: string = '';
  @Input() tipoRegistroProduto: string = '';
  @Input() ansProduto: string = '';
  @Input() acomadacaoPlano: string = '';
  @Input() dataAssinaturaDadosBancarios: string = '';
  @Input() horaAssinaturaDadosBancarios: string = '';
  @Input() totalPlano!: number;
  @Input() totalPlanoComTaxa!: number;
  @Input() tipoPropostaTitular!: TipoPropostaEnum;
  @Input() beneficiarios: any;
  @Input() cpfTitular: string = '';
  @Input() tipoProduto!: TipoProduto_E_OperadoraEnum;
  @Input() dadosOperadoraDM: any;
  @Input() valorRecebidoPeloBeneficiario: any;
  @Input() heMedSenior: any;
  // @Input() dadosOperadoraCabecalho!: any;
  @Input() dadosOperadoraCabecalho: any;
  tipoProdutoEnum = TipoProduto_E_OperadoraEnum;
  operadoraVM!: any;
  heOdontoPrev: boolean = false;
  ehuniodonto: boolean = false;
  udemo_e_apase: boolean = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.operadoraVM = this.carregarDadosOperadoraPagamento();
    this.criarFormDadosBancarios();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.operadoraVM = this.carregarDadosOperadoraPagamento();
    }, 1000);
  }

  criarFormDadosBancarios() {
    this.formularioDadosBancarios = this.formBuilder.group({
      bank: new FormControl(null),
      agency: new FormControl(null),
      agencyDigit: new FormControl(null),
      account: new FormControl(null),
      accountDigit: new FormControl(null),
      name: new FormControl(null),
      age: new FormControl(null),
      value: new FormControl(null),
      //campos que não recebe dados do Banco
      tipoConta: new FormControl(''),
    });
  }

  preencherDados(dados: any) {
    const dadosBancarios = dados;
    this.formularioDadosBancarios.patchValue({
      bank: dadosBancarios.bank.name,
      agency: dadosBancarios.agency,
      agencyDigit: dadosBancarios.agencyDigit,
      account: dadosBancarios.account,
      accountDigit: dadosBancarios.accountDigit,
    });
  }

  calcularIdade(dataNascimento: string): number {
    if (!dataNascimento) return 0;

    try {
      const dataNasc = new Date(dataNascimento);

      if (isNaN(dataNasc.getTime())) return 0;

      const hoje = new Date();
      let idade = hoje.getFullYear() - dataNasc.getFullYear();

      // Verifica se já fez aniversário este ano
      const mesAtual = hoje.getMonth();
      const diaAtual = hoje.getDate();
      const mesNasc = dataNasc.getMonth();
      const diaNasc = dataNasc.getDate();

      if (mesAtual < mesNasc || (mesAtual === mesNasc && diaAtual < diaNasc)) {
        idade--;
      }

      return idade;
    } catch (error) {
      return 0;
    }
  }

  isOdonto(): boolean {
    return TipoProduto_E_OperadoraComponent.isOdonto(this.tipoProduto);
  }

  carregarDadosOperadoraPagamento(): string {
    debugger;
    var dadosOepradoraOdontoPrev = TipoProduto_E_OperadoraComponent.getByCnpj(
      this.dadosOperadoraDM?.operatorObject?.cnpj,
    );
    if (dadosOepradoraOdontoPrev && dadosOepradoraOdontoPrev.tipo == this.tipoProdutoEnum.ODONTOPREV)
      this.heOdontoPrev = true;

    const entidadeConfig = EntidadeConfig.getConfig(this.dadosOperadoraDM.branchCompanyName || '');
    // verifica se é uniodonto
    if (dadosOepradoraOdontoPrev && dadosOepradoraOdontoPrev.tipo == this.tipoProdutoEnum.UNIODONTO)
      this.ehuniodonto = true;

    // ESTIPULADO
    this.udemo_e_apase = entidadeConfig.tipo == EntidadeEnum.UDEMO || entidadeConfig.tipo == EntidadeEnum.APASE;

    const cnpjOperadoraFiltro = this.dadosOperadoraDM?.operatorObject && this.dadosOperadoraDM?.operatorObject?.cnpj;
    if (!cnpjOperadoraFiltro) {
      return '../../../../../../assets/app-assets/images/logos-empresas/default.png';
    }
    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    return dadosOperadora;
  }

  get tipoCobranca(): string {
    const isInclusao = this.dadosOperadoraCabecalho?.ehInclusaoDependente;

    if (isInclusao) {
      if (this.isOdonto() && this.heOdontoPrev) return 'odontoprev_inclusao_dependente';
      if (!this.isOdonto()) return 'saude_inclusao_dependente';
    }

    if (this.udemo_e_apase || this.heOdontoPrev) return 'udemo_apase';
    if (this.isOdonto()) return 'odonto_comum';
    return 'padrao';
  }

  get mesReferencia(): string {
    const isInclusao = this.dadosOperadoraCabecalho?.ehInclusaoDependente;

    if (isInclusao && this.isOdonto() && this.ehuniodonto) return '5º dia útil do mês subsequênte';
    if (this.udemo_e_apase || this.heOdontoPrev) return '01 do mês subsequênte';
    return '01 do mês subsequênte';
  }

  get dataVencimento(): string {
    if (this.isOdonto() || this.udemo_e_apase) {
      return '5º dia útil';
    }
    return '5º dia útil a partir da vigência';
  }
}
